if(!customElements.get('cookies-popup')) {
  class CookiesPopup extends HTMLElement {
    constructor() {
      super();

      this.elParent = this.closest('popup-modals');
      
      this.elAccept = this.elParent.querySelectorAll('[data-accept]');
      this.elDecline = this.querySelector('[data-decline]');

      this.hasApi = false;

      this.loadAPI();

      this.elAccept.forEach(el => el.addEventListener('click', this.acceptCookies.bind(this)));
      this.elDecline.addEventListener('click', this.declineCookies.bind(this));
    }

    loadAPI() {
      const options = [{ name: 'consent-tracking-api', version: '0.1' }];
      const callback = (error) => {
        this.hasApi = !error;
        error && console.log(error);
        if(error) return;
      }

      window.Shopify.loadFeatures(options, callback);
    }

    setConsent(analytics, marketing, preferences) {
      if(this.hasApi) {
        const props = {
          "analytics": analytics,
          "marketing": marketing,
          "preferences": preferences
        }

        console.log(props);
        const callback = (e) => {
          console.log(e, "Consent captured");
          this.elParent.closeActivePopup();
        }

        window.Shopify.customerPrivacy.setTrackingConsent(props, callback);
      } else {
        this.elParent.closeActivePopup();
      }
    }

    acceptCookies(ev) {
      ev.preventDefault();
      this.setConsent(true, true, true);
    }

    declineCookies(ev) {
      ev.preventDefault();
      this.setConsent(false, false, false);
    }
  }

  customElements.define('cookies-popup', CookiesPopup);
}